import Vue from 'vue'
import VueI18n from 'vue-i18n'
import router from '@/router'
import pluralization from './pluralization.js'
Vue.use(VueI18n)

let localization = router.history._startLocation,
  language = localization.toLowerCase().startsWith('/en')
    ? 'en'
    : 'uk'
language ||= 'uk'

const lng2code = {
  uk: 'uk-UA',
  en: 'en-US'
}


VueI18n.prototype.getChoiceIndex = pluralization.getChoiceIndex(language)

if (!VueI18n.prototype.__patchedLongDateD) {
  const __originalD = VueI18n.prototype.d
  VueI18n.prototype.d = function (value, ...args) {
    const res = __originalD.apply(this, [value, ...args])
    try {
      const key = args[0]
      if (key === 'longDate' && typeof res === 'string') {
        return res.replace(/\s*,\s*/g, ' ')
      }
    } catch (e) {
      /* */
    }
    return res
  }
  VueI18n.prototype.__patchedLongDateD = true
}

// Load all locales and remember context
function loadMessages() {
  // Лише локалі, які можуть стати активними (uk/en, за префіксом URL); ru.json у бандл не потрапляє
  const context = require.context('./locales', true, /(uk|en)\.json$/i)
  const messages = context
    .keys()
    .map((key) => ({ key, locale: key.match(/[a-z0-9-_]+/i)[0] }))
    .reduce(
      (messages, { key, locale }) => ({
        ...messages,
        [locale]: context(key),
      }),
      {}
    )

  return { context, messages }
}
const { context, messages } = loadMessages()

export const currentLang = () => {
  
  sessionStorage.language = language
  sessionStorage.VueAppLanguage = language == 'uk' ? 'ua' : language
  sessionStorage.languageCode =  lng2code[language]
  return language
}

export const i18n = new VueI18n({
  silentTranslationWarn: true,
  locale: currentLang(),
  fallbackLocale: 'uk',
  dateTimeFormats: pluralization.dateTimeFormats,
  numberFormats: pluralization.numberFormats,
  messages,
})

i18n.$setLocaleCookie = function(c) {
  
  //Set for year
  let age = 60 * 60 * 24 * 365
  document.cookie = `c=${c}; path=/; max-age=${age}; samesite=lax`
}
i18n.$setLocaleCookie(language)

// Hot updates
if (module.hot) {
  module.hot.accept(context.id, () => {
    const { messages: newMessages } = loadMessages()

    Object.keys(newMessages)
      .filter((locale) => messages[locale] !== newMessages[locale])
      .forEach((locale) => {
        messages[locale] = newMessages[locale]
        i18n.setLocaleMessage(locale, messages[locale])
      })
  })
}